import type { Object3D } from 'three';

export const enableLayerOne = (obj: Object3D): void => obj.layers.enable(1);
